import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { AppThemeProvider } from './utils/ThemeContext';
import { AuthProvider, useAuth } from './utils/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import MfaSetup from './pages/MfaSetup';
import Dashboard from './pages/Dashboard';
import Tenants from './pages/Tenants';
import Users from './pages/Users';
import AuditLog from './pages/AuditLog';
import Scan from './pages/Scan';
import Sync from './pages/Sync';
import Settings   from './pages/Settings';
import Analytics  from './pages/Analytics';
import Provision  from './pages/Provision';

const ProtectedRoute = ({ children, minRole }) => {
  const { user, loading, hasRole } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.mfaSetupRequired) return <Navigate to="/mfa-setup" replace />;
  if (minRole && !hasRole(minRole)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
};

export default function App() {
  return (
    <AppThemeProvider>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login"    element={<Login />} />
            <Route path="/mfa-setup" element={<MfaSetupGuard />} />
            <Route path="/"         element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/tenants"  element={<ProtectedRoute><Tenants /></ProtectedRoute>} />
            <Route path="/users"    element={<ProtectedRoute minRole="admin"><Users /></ProtectedRoute>} />
            <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
            <Route path="/audit"    element={<ProtectedRoute><AuditLog /></ProtectedRoute>} />
            <Route path="/scan"     element={<ProtectedRoute><Scan /></ProtectedRoute>} />
            <Route path="/sync"     element={<ProtectedRoute minRole="operator"><Sync /></ProtectedRoute>} />
            <Route path="/provision" element={<ProtectedRoute minRole="admin"><Provision /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute minRole="admin"><Settings /></ProtectedRoute>} />
            <Route path="*"         element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </AppThemeProvider>
  );
}

function MfaSetupGuard() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.mfaSetupRequired) return <Navigate to="/" replace />;
  return <MfaSetup />;
}
